var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationsA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00361F;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M446.2,389.4c-0.2-33.9-21.5-63.2-52.7-74.3v-82.5c0-62.7-42.1-115.7-99.5-132.3c0.8-3.2,1.2-6.5,1.2-9.8 c0-21.8-17.8-39.5-39.5-39.5s-39.4,17.7-39.4,39.5c0,3.3,0.4,6.6,1.3,9.8c-57.4,16.6-99.5,69.6-99.5,132.3v82.5 c-30.9,11.1-52.5,41-52.7,74.3l-0.1,19.4h118.3c10.1,30.7,38.9,52.1,72.1,52.1c33,0,61.9-21.4,72-52.1h118.5V389.4z M239.3,90.6 c0-9.1,7.4-16.4,16.4-16.4c9.1,0,16.4,7.4,16.4,16.4c0,1.8-0.3,3.5-0.9,5.2c-5.1-0.6-10.2-0.9-15.4-0.9c-5.3,0-10.5,0.3-15.6,0.9 C239.6,94.2,239.3,92.4,239.3,90.6z M255.6,437.8c-20.3,0-38.4-11.6-47.2-29h94.3C293.9,426.2,275.8,437.8,255.6,437.8z  M195.7,385.8c-1.7-0.5-3.6-0.7-5.4-0.3c-0.4,0.1-0.8,0.2-1.2,0.3H88.6c1.8-24.3,19.6-45.3,43.5-50.8l5.6-1.3h164.5 c6.3,0,11.5-5.1,11.5-11.5c0-6.3-5.1-11.5-11.5-11.5H141.1v-78.1c0-63.3,51.4-114.7,114.6-114.7c63.3,0,114.7,51.5,114.7,114.7v78.1 h-15c-6.3,0-11.5,5.1-11.5,11.5c0,6.3,5.1,11.5,11.5,11.5h18.4l5.6,1.3c23.9,5.5,41.7,26.5,43.5,50.8H195.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsA);
export default __webpack_public_path__ + "static/media/notificationsA.f4883e9da238aa2b9e8104e560c0e68b.svg";
export { ForwardRef as ReactComponent };